const siteHeader = document.querySelector('.site-header')
// Check if window is scrolled by at least 8x
const scrollCheck = () => {
    if (window.scrollY > 8) {
        // add class to html element
        if (!document.documentElement.classList.contains('stay-dark')) {
            document.documentElement.classList.add('dark')
        }
        siteHeader.classList.add('shadow-sm')
    } else {
        if (!document.documentElement.classList.contains('stay-dark')) {
            document.documentElement.classList.remove('dark')
        }
        siteHeader.classList.remove('shadow-sm')
    }
}
// Listen for scroll events
window.addEventListener('scroll', scrollCheck)
// Run scrollCheck on load
scrollCheck()
